import { AfterViewInit, Component, ElementRef } from '@angular/core';
import { BatchService } from '../Services/batch.service';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgxPrintModule } from 'ngx-print';
import { NgxBarcode6Module } from 'ngx-barcode6';
import { ZXingScannerModule } from '@zxing/ngx-scanner';
import { BarcodeFormat } from '@zxing/library';
import { ScanmedicationComponent } from '../scanmedication/scanmedication.component';
import Swal from 'sweetalert2';
import { Router,ActivatedRoute } from '@angular/router';
import { ViewChild } from '@angular/core';
import { PicklistService } from '../Services/picklist.service';
import { HostListener } from '@angular/core';
@Component({
  selector: 'app-batches',
  imports: [
    CommonModule,
    HttpClientModule,
    NgxPrintModule,
    NgxBarcode6Module,
    ZXingScannerModule,
    ScanmedicationComponent
  ],
  templateUrl: './batches.component.html',
  styleUrl: './batches.component.css',
  providers: [BatchService,PicklistService],
})
export class BatchesComponent implements AfterViewInit {
  @ViewChild('barcodeInput') barcodeInput!: ElementRef<HTMLInputElement>;
  @ViewChild(ScanmedicationComponent)
  scanMedicationComp!: ScanmedicationComponent;
  storeBatchData: any = {};
  numberOfPrescriptions: number = 0;
  numberOfMedications: number = 0;
  medicationsPerPatient: any[] = [];
  groupedMedications: any = {};
  batchData: any = {};
  selectedMedications: string[] = [];
  printMedications: any = [];
  disabled: boolean = false;
  isWrongMedicine: boolean = false;
  medicationIdList: string[] = [];
  makeSummaryDisable: boolean = false;
  cameraPermissionStatus: string = 'Checking permission...';
  cameraGranted:boolean = false;
  batchId:string = "";
  isStartBtnClicked:boolean = true;
  finishedScan:boolean = false;
  isFormDirty = false;
  todayDate: string = '';
  @HostListener('window:beforeunload', ['$event'])
  handleBeforeUnload(event: BeforeUnloadEvent) {
    if (this.isFormDirty) {
      event.preventDefault();
      event.returnValue = '';
    }
  }
  //scanner
  // scanResult: string = '';
  isScannerActive: boolean = false;
  isScanSuccessful: boolean = false;
  barcodeFormats = [
    BarcodeFormat.EAN_13,
    BarcodeFormat.UPC_A,
    BarcodeFormat.CODE_39,
    BarcodeFormat.CODE_128,
    BarcodeFormat.EAN_8,
    BarcodeFormat.ITF,
  ];
  constructor(private _batchservice: BatchService,
    private _picklistservice: PicklistService, private router:Router,private activatedRoute: ActivatedRoute) {}
  ngOnInit(): void {
    this.todayDate = new Date().toLocaleDateString('en-GB'); // DD/MM/YYYY
    this.startScanner();
    this.activatedRoute.paramMap.subscribe(params => {
      this.batchId = params.get('batchId') || '';
      this._batchservice.getBatchById(this.batchId).subscribe((response: any) => {
        this.storeBatchData = response.result; 
        if (this.storeBatchData) {
          this.batchData = this.storeBatchData;
          this.numberOfPrescriptions = this.storeBatchData.prescriptions.length;
          this.numberOfMedications = this.storeBatchData.prescriptions.reduce(
            (total: number, prescription: any) =>
              total + prescription.medications.length,
            0
          );
          this.medicationList();
          this.getMedicationsList();
          this.printMedicationList();
        }
      });
    });
    setInterval(() => {
      this.checkCameraPermission();
    }, 1000);
  }
  ngAfterViewInit(): void {
  setTimeout(() => {
    if (this.barcodeInput) {
      this.barcodeInput.nativeElement.focus();
      this.barcodeInput.nativeElement.addEventListener('blur', () => {
        setTimeout(() => this.barcodeInput.nativeElement.focus(), 0);
      });
    }
  }, 500);
}
  onInputChange() {
    this.isFormDirty = true;
  }
  checkCameraPermission() {
    navigator.permissions.query({ name: 'camera' as PermissionName })
      .then((permissionStatus) => {
        if (permissionStatus.state === 'granted') {
          this.cameraGranted = true;
          this.cameraPermissionStatus = '';
        } else if (permissionStatus.state === 'prompt') {
          this.cameraPermissionStatus = '⚠️ Camera permission needs to be requested.';
          this.cameraGranted = false;
        } else {
          this.cameraPermissionStatus = '❌ Camera access is denied.';
          this.cameraGranted = false;
        }
      })
      .catch((error) => {
        this.cameraPermissionStatus = '⚠️ Error checking camera permission.';
      });
  }
  //picklist
  medicationList(){
    if (this.storeBatchData != null) {
      this.batchData = this.storeBatchData;
      this.groupedMedications = this._picklistservice.printPickList(this.batchData);
    }
  }
  startScanner() {
    this.isScannerActive = true;
    this.makeSummaryDisable = true;
    this.activatedRoute.paramMap.subscribe(params => {
      this.batchId = params.get('batchId') || '';
      const status = "InProgress";
      this._batchservice.updateBatchStatus(this.batchId, status).subscribe((response: any) => {
        // console.log(response);
      });
    });
    this.isStartBtnClicked = true;
    // setTimeout(() => {
    //   const barcodeInput = document.querySelector('input[id="barcodeinput"]') as HTMLInputElement;
    //   console.log("barcode data: ",barcodeInput.value);
    //   if (barcodeInput) {
    //     barcodeInput.focus();
    //   }
    // }, 100);
    setTimeout(() => {
      if (this.barcodeInput) {
        this.barcodeInput.nativeElement.focus();
      }
    }, 100);
  }
  stopScanner() {
    this.isScannerActive = false; 
    this.printMedicationList();
  }
  printPackedList(){
    setTimeout(() => {
      const printContents = document.getElementById('print-medicines')?.innerHTML;
      if (printContents) {
        const printContainer = document.createElement('div');
        printContainer.id = "print-container"; 
        printContainer.innerHTML = printContents;
        document.body.appendChild(printContainer);
        const style = document.createElement('style');
        style.innerHTML = 
          `@media print {
            body * {
              display: none !important;
            }
            #print-container, #print-container * {
              display: block !important;
            }}`;
        document.head.appendChild(style);
        window.onafterprint = () => {
          Swal.fire({
            title:"Please select",
            text: "Do you want to continue scanning current batch,or request for a new batch?",
            showCancelButton: true,
            confirmButtonColor: "#008000",
            cancelButtonColor: "#3085d6",
            cancelButtonText: "Current Batch",
            confirmButtonText: "Request New Batch",
            allowOutsideClick: false
          }).then((result) => {
            if (result.isConfirmed) {
              this.router.navigate(['/batchlist']);
            }
          });
          document.body.removeChild(printContainer);
          document.head.removeChild(style);
        };
        window.print();
      }
    }, 500);
  }
  printMedicationList() {
    this.printMedications = [];
    this.batchData.prescriptions.forEach((prescription: any) => {
      prescription.medications.forEach((medication: any) => {
        if (medication.isAvailable === true) {
          this.printMedications.push({
            medicationName: medication.medicationName,
            medicineDosage: medication.dosage,
            instruction: medication.instruction,
            medicationId: medication.medicationId,
          });
        }
      });
    });    
  }
  onScanResult(result: string) {
    if (result) {
      try {
        this.scanMedicationComp.listOfAvailability(result);
        this.printMedicationList(); 
      } catch (error) {
        Swal.fire({
          title: 'Error!',
          text: 'Failed to scan the medicine. Try again.',
          icon: 'error',
          timer: 2000,
          confirmButtonText: 'OK',
        });
      }
    }
  }
  get objectKeys(): (obj: any) => string[] {
    return Object.keys;
  }
  getMedicationsList() {
    this.batchData.prescriptions.forEach((prescription: any) => {
      prescription.medications.forEach((medication: any) => {
        this.medicationIdList.push(medication.medicationId);
      });
    });
    return (this.medicationIdList = [...new Set(this.medicationIdList)]);
  }
  isScanFinished(status:boolean){
    this.finishedScan = status;
  }
  canDeactivate(): boolean | Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.activatedRoute.paramMap.subscribe(params => {
        this.batchId = params.get('batchId') || '';
        this._batchservice.getBatchById(this.batchId).subscribe((response: any) => {
          this.storeBatchData = response.result;
          if (this.storeBatchData?.status === 'Completed') {
            resolve(true);
          } else {
            Swal.fire({
              title: "Are you sure?",
              text: "You are about to leave the scanning page.",
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: "#d33",
              cancelButtonColor: "#3085d6",
              cancelButtonText: "Stay",
              confirmButtonText: "Leave",
              allowOutsideClick: false
            }).then((result) => {
              resolve(result.isConfirmed);
            });
          }
        });
      });
    });
  }
  handleBarcode(inputElement: HTMLInputElement) {
    if (!this.isScannerActive) {
      return;
    }
    const scannedValue = inputElement.value.trim();
    if (scannedValue) {
      this.onScanResult(scannedValue);
      inputElement.value = '';
    }
  } 
  getLastChars(id: string): string {
  if (!id) return '';
  return id.slice(-8);
}
triggerPrintPickList() {
    const printContents = document.getElementById('printlist')?.innerHTML;
    if (!printContents) return;

    const popupWin = window.open('', '_blank', 'width=800,height=600');

    if (popupWin) {
      popupWin.document.open();
      popupWin.document.write(`
<html>
  <head>
    <title>Batch Pick List</title>
    <style>
      body {
        font-family: "Segoe UI", Inter, Roboto, -apple-system, BlinkMacSystemFont, Arial, sans-serif;
        padding: 16px 18px;
        margin: 0;
      }

      .print-container { width: 100%; }

      .print-top-bar {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }

      .print-date {
        font-size: 13px;
        color: #555;
        font-weight: 500;
      }

      .print-logos {
        display: flex;
        align-items: center;
        gap: 14px;
      }

      .print-logo { height: 34px; }

      hr {
        border: none;
        border-top: 0.8px solid #e0e0e0;
        margin: 4px 0 10px 0;
      }

      .print-title {
        margin: 6px 0 10px 0;
        font-size: 19px;
        font-weight: 700;
      }

      table {
        width: 100%;
        border-collapse: collapse;
      }

      thead th {
        text-align: left;
        padding: 5px 6px;
        font-weight: 700;
        font-size: 14px;
        border-bottom: 1px solid #e0e0e0;
      }

      tbody td {
        padding: 5px 6px;
        text-align: left;
        font-size: 13.5px;
        border-bottom: 1px solid #e0e0e0;
      }

      tbody tr:last-child td {
        border-bottom: none;
      }

      .col-stock { width: 48%; }
      .col-prescription { width: 27%; }
      .col-qty { width: 10%; }
      .col-picked { width: 15%; }
    </style>
  </head>
  <body onload="window.print(); window.close();">
    ${printContents}
  </body>
</html>
`);
      popupWin.document.close();
    }
  }

}